import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfigService } from '@common/util-foundation';
import { UpdateAutoRenewalRequest } from '@common/util-models';
import { Observable } from 'rxjs';

@Injectable()
export class AutoRenewalApiService {
  constructor(
    private httpClient: HttpClient,
    private buildConfigService: BuildConfigService
  ) {}

  get isEnabled(): boolean {
    return !!this.buildConfigService.config.customerSupportApi;
  }

  updateAutoRenewal(request: UpdateAutoRenewalRequest): Observable<unknown> {
    const url = `${this.buildConfigService.config.customerSupportApi}/api/v1/update-auto-renewal`;
    return this.httpClient.post(url, request, {
      headers: {
        'wl-client': this.buildConfigService.config.wlClient,
        'request-source': this.buildConfigService.config.catalogueStore,
        'request-action': this.buildConfigService.config.action,
      },
    });
  }
}
